(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Product', 'ProductCategory', 'TaxClass', 'MeasurementUnit'];

    function ProductDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Product, ProductCategory, TaxClass, MeasurementUnit) {
        var vm = this;
        vm.product = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
